import { limitLines } from './limitLines';

export const CodeBlock = ({
  content,
  maxLines,
}: {
  content: string | object;
  maxLines?: number;
}) => (
  <pre className="flex-[1_0_auto] overflow-x-hidden border border-[#ccc] bg-[#eee]">
    <code>{limitLines(content, maxLines)}</code>
  </pre>
);
